import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function endShift() {
    let response = await axios.post(routes.endShift, {}, AXIOS_DEFAULT_CONFIG);
    return response;
}